import { useState } from "react"
import clsx from "clsx"

import { useTranslation } from "react-i18next"

import { BetbyDbTemplate } from "services/betbyBonus/betbyBonus.service"

import { IssueBonusForm } from "./components/IssueBonusForm"
import { IssuedBonusesTable } from "./components/IssuedBonusesTable"
import { TemplateConfigTable } from "./components/TemplateConfigTable"
import { TemplateSelector } from "./components/TemplateSelector"

type Tab = "templates" | "give" | "list"

export const BetbyBonusesPage = () => {
  const [activeTab, setActiveTab] = useState<Tab>("templates")
  const [selectedTemplate, setSelectedTemplate] = useState<BetbyDbTemplate | null>(null)
  const { t } = useTranslation("translation", { useSuspense: false })

  const TABS: { key: Tab; label: string }[] = [
    { key: "templates", label: t("betbyBonuses.tabTemplates") },
    { key: "give", label: t("betbyBonuses.tabGiveBonus") },
    { key: "list", label: t("betbyBonuses.tabIssuedBonuses") }
  ]

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-1">{t("betbyBonuses.title")}</h1>
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">{t("betbyBonuses.description")}</p>

      {/* Tabs */}
      <div className="flex gap-1 mb-6 border-b dark:border-gray-700">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={clsx(
              "px-5 py-2 text-sm font-medium border-b-2 transition-colors",
              activeTab === tab.key
                ? "border-blue-500 text-blue-600 dark:text-blue-400"
                : "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
            )}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      {activeTab === "templates" && <TemplateConfigTable />}

      {activeTab === "give" && (
        <div className="space-y-6">
          <TemplateSelector onSelect={(t) => setSelectedTemplate(t)} />
          {selectedTemplate && <IssueBonusForm template={selectedTemplate} />}
        </div>
      )}

      {activeTab === "list" && <IssuedBonusesTable />}
    </div>
  )
}
